import { DnmRequestFailure } from '../../api/dnmFailure';
import { opsUserName } from './opsUser';

/** Friendly copy for ownership mutations (contract §3 409 codes). */
export function ownershipErrorMessage(error: unknown): string {
  if (error instanceof DnmRequestFailure) {
    switch (error.code) {
      case 'OWNERSHIP_CONFLICT':
        return error.owner
          ? `Already owned by ${opsUserName(error.owner)}. Refresh to see the latest owner.`
          : 'Someone else claimed this shipment first. Refresh to see the latest owner.';
      case 'CAP_REACHED':
        return 'You’re at your open-order cap. Release or close an order before claiming another.';
      case 'SHIPMENT_CLOSED':
        return 'This shipment is closed (completed, cancelled or expired), so ownership can’t change.';
      case 'ASSIGNEE_UNAVAILABLE':
        return 'That teammate is away or inactive. Pick an active ops user.';
      default:
        break;
    }
    if (error.response?.status === 403) {
      return 'Only the current owner or an ops manager can do this.';
    }
    return error.message;
  }
  return error instanceof Error ? error.message : 'Something went wrong. Please try again.';
}
